function normalizeOrderId(value) {
  if (value === undefined || value === null) {
    return "";
  }

  return value.toString();
}

function getLatestSyncOrderIdSet(latestSyncOrderIds) {
  return new Set((latestSyncOrderIds || []).map(normalizeOrderId).filter(Boolean));
}

function getOrderLocalId(order) {
  return normalizeOrderId(
    order && (order.Id || order.id || order.stripeSessionId || order.orderId),
  );
}

function isNewlySyncedOrder(order, latestSyncOrderIds) {
  return getLatestSyncOrderIdSet(latestSyncOrderIds).has(getOrderLocalId(order));
}

module.exports = {
  getLatestSyncOrderIdSet,
  getOrderLocalId,
  isNewlySyncedOrder,
};
